module.exports = __webpack_public_path__ + "img/list-nested.0a6fa97b.svg";